import { Diagnostic, Rule } from "@siteimprove/alfa-act";
import { Element, Namespace, Node, Query, } from "@siteimprove/alfa-dom";
import { Predicate } from "@siteimprove/alfa-predicate";
import { Err, Ok } from "@siteimprove/alfa-result";
import { String } from "@siteimprove/alfa-string";
import { Criterion, Technique } from "@siteimprove/alfa-wcag";
import { expectation } from "../common/act/expectation.js";
import { withDocumentElement } from "../common/applicability/with-document-element.js";
import { Scope, Stability } from "../tags/index.js";
const { hasName, hasNamespace } = Element;
const { hasTextContent } = Node;
const { and, not } = Predicate;
const { getElementDescendants } = Query;
export default Rule.Atomic.of({
    uri: "https://alfa.siteimprove.com/rules/sia-r1",
    requirements: [
        Criterion.of("2.4.2"),
        Technique.of("G88"),
        Technique.of("H25"),
    ],
    tags: [Scope.Page, Stability.Stable],
    evaluate({ document }) {
        return {
            applicability() {
                return withDocumentElement(document);
            },
            expectations(target) {
                const title = getElementDescendants(target).find(and(hasNamespace(Namespace.HTML), hasName("title")));
                return {
                    1: expectation(title.isSome(), () => Outcomes.HasTitle, () => Outcomes.HasNoTitle),
                    2: expectation(title.some(hasTextContent(not(String.isWhitespace))), () => Outcomes.HasNonEmptyTitle, () => Outcomes.HasEmptyTitle),
                };
            },
        };
    },
});
/**
 * @public
 */
export var Outcomes;
(function (Outcomes) {
    Outcomes.HasTitle = Ok.of(Diagnostic.of(`The document has at least one \`<title>\` element`));
    Outcomes.HasNoTitle = Err.of(Diagnostic.of(`The document does not have a \`<title>\` element`));
    Outcomes.HasNonEmptyTitle = Ok.of(Diagnostic.of(`The first \`<title>\` element has text content`));
    Outcomes.HasEmptyTitle = Err.of(Diagnostic.of(`The first \`<title>\` element has no text content`));
})(Outcomes || (Outcomes = {}));
//# sourceMappingURL=rule.js.map